import Alert from "components/common/Alert";
import { useEffect, useRef, useState } from "react";
import { getExhibitorDropdown } from "api/exhibitor.api";
import { useEvents } from "components/events/hooks/useEvents";
// import { useExhibitors } from "components/exhibitor/hooks/useExhibitors";
import { getImageUrl } from "utils/imageHelper";
import PageLayout from ".././PageFromLayout";
import { InputField, SelectField, ImageUploadField } from ".././FormFields";
// import { FiArrowRight } from "react-icons/fi";
import FormSection from ".././FormSection";
import { validateImageFile } from "utils/common";
const VISIBILITY_ROLES = [
  "Exhibitors",
  "Events",
  "Offers",
  "Products",
  "Articles",
  "Confirm Page",
];

export default function BannerForm({ initialData = null, onSubmit, onClose }) {
  const { data, loadEvents } = useEvents();
  // const { exhibitors } = useExhibitors();
  const [exhibitors, setExhibitors] = useState([]);

  const fileInputRef = useRef(null);

  const alertRef = useRef(null);
  const [alert, setAlert] = useState("");

  const [errors, setErrors] = useState({});

  const [form, setForm] = useState({
    company_id: "",
    title: "",
    banner_type: "Hero",
    links_to: "Common",
    redirect_url: "",
    event_id: "",
    exhibitor_id: "",
    start_date: "",
    end_date: "",
    alt_text: "",
    status: "live",
    visibility: [],
  });

  const [bannerMedia, setBannerMedia] = useState(null);

  const [preview, setPreview] = useState(null);

  const [mediaType, setMediaType] = useState("image");

  const [mediaRemoved, setMediaRemoved] = useState(false);
  const [loader, setLoader] = useState(false);
  useEffect(() => {
    if (!initialData) return;

    setForm({
      company_id: initialData.company_id?._id || "",
      title: initialData.title || "",
      banner_type: initialData.banner_type || "Hero",
      links_to: initialData.links_to || "Common",
      redirect_url: initialData.link || "",
      event_id: initialData.event_id?._id || "",
      exhibitor_id: initialData.exhibitor_id?._id || "",
      start_date: initialData.start_date
        ? initialData.start_date.slice(0, 16)
        : "",
      end_date: initialData.end_date ? initialData.end_date.slice(0, 16) : "",
      alt_text: initialData.alt_text || "",
      status: initialData.status || "active",
      visibility: initialData.visibility || [],
    });

    if (initialData.media_type === "video" && initialData.banner_video) {
      setMediaType("video");
      setPreview({
        url: getImageUrl(initialData.banner_video),
        type: "video",
      });
    } else if (initialData.banner_image) {
      setMediaType("image");
      setPreview({
        url: getImageUrl(initialData.banner_image),
        type: "image",
      });
    }
  }, [initialData]);

  useEffect(() => {
    if (alert && alertRef.current) {
      alertRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [alert]);

  useEffect(() => {
    const companyId = localStorage.getItem("company_id");
    if (!companyId) return;

    if (form.links_to === "Event") {
      loadEvents(companyId);
    }

    if (form.links_to === "Exhibitor") {
      getExhibitorDropdown(companyId)
        .then((res) => setExhibitors(res.data || []))
        .catch(() => setExhibitors([]));
    }

    if (form.links_to === "Common") {
    }
  }, [form.links_to]);

  useEffect(() => {
    const companyId = localStorage.getItem("company_id");
    if (!companyId) return;

    if (initialData?.links_to === "Event") {
      loadEvents(companyId);
    }

    if (initialData?.links_to === "Exhibitor") {
      getExhibitorDropdown(companyId)
        .then((res) => setExhibitors(res.data || []))
        .catch(() => setExhibitors([]));
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    setErrors((p) => ({
      ...p,
      [name]: "",
    }));
  };

  const toggleRole = (role) => {
    setForm((p) => ({
      ...p,
      visibility: p.visibility.includes(role)
        ? p.visibility.filter((r) => r !== role)
        : [...p.visibility, role],
    }));
  };

  const handleImageChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const isImage = file.type.startsWith("image/");
    const isVideo = file.type.startsWith("video/");

    // 1. Basic format check
    if (!isImage && !isVideo) {
      setErrors((p) => ({
        ...p,
        bannerMedia: "Only image or video files are allowed",
      }));
      return;
    }

    // 2. Image validation using validateImageFile (2 MB limit)
    if (isImage) {
      const { isValid, error } = await validateImageFile(file, 5);
      if (!isValid) {
        setErrors((p) => ({ ...p, bannerMedia: error }));
        return;
      }
    }

    // 3. Video size validation (20 MB limit)
    if (isVideo && file.size > 20 * 1024 * 1024) {
      setErrors((p) => ({ ...p, bannerMedia: "Video must be under 20MB" }));
      return;
    }

    // 4. Clear error and update states
    setErrors((p) => ({ ...p, bannerMedia: "" }));

    const mediaKind = isImage ? "image" : "video";
    setMediaType(mediaKind);
    setBannerMedia(file);

    const url = URL.createObjectURL(file);
    setPreview({
      url,
      type: mediaKind,
    });

    setMediaRemoved(false);
  };

  const removeImage = () => {
    setBannerMedia(null);
    setPreview(null);
    setMediaRemoved(true);

    setErrors((p) => ({
      ...p,
      bannerMedia:
        mediaType === "image"
          ? "Banner image is required"
          : "Banner video is required",
    }));

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!form.title.trim()) {
      newErrors.title = "Banner title is required";
    }

    if (!form.banner_type) {
      newErrors.banner_type = "Banner type is required";
    }

    if (!form.links_to) {
      newErrors.links_to = "Banner link type is required";
    }

    if (form.links_to === "Common" && !form.redirect_url.trim()) {
      newErrors.redirect_url = "Redirect URL is required";
    }

    if (form.links_to === "Event" && !form.event_id) {
      newErrors.event_id = "Event is required";
    }

    if (form.links_to === "Exhibitor" && !form.exhibitor_id) {
      newErrors.exhibitor_id = "Exhibitor is required";
    }

    if (!form.start_date) {
      newErrors.start_date = "Start date is required";
    }

    if (!form.end_date) {
      newErrors.end_date = "End date is required";
    }

    if (form.start_date && form.end_date) {
      if (new Date(form.start_date) > new Date(form.end_date)) {
        newErrors.end_date = "End date must be after start date";
      }
    }

    if (!form.visibility.length) {
      newErrors.visibility = "Select at least one visibility option";
    }

    if (!bannerMedia && (!initialData || mediaRemoved)) {
      newErrors.bannerMedia =
        mediaType === "image"
          ? "Banner image is required"
          : "Banner video is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const submit = async (e) => {
    e.preventDefault();

    // 1. Validate early before preparing data
    if (!validate()) {
      setAlert("Please fix the errors below");
      return;
    }

    // 2. Prepare FormData
    const fd = new FormData();

    if (form.title) fd.append("title", form.title.trim());
    if (form.banner_type) fd.append("banner_type", form.banner_type);
    if (form.links_to) fd.append("links_to", form.links_to);
    if (form.status) fd.append("status", form.status);
    if (form.alt_text) fd.append("alt_text", form.alt_text.trim());

    if (form.redirect_url) fd.append("link", form.redirect_url.trim());
    if (form.event_id) fd.append("event_id", form.event_id);
    if (form.exhibitor_id) fd.append("exhibitor_id", form.exhibitor_id);
    if (form.start_date) fd.append("start_date", form.start_date);
    if (form.end_date) fd.append("end_date", form.end_date);

    // Array fields handling
    if (Array.isArray(form.visibility) && form.visibility.length > 0) {
      form.visibility.forEach((v) => fd.append("visibility[]", v));
    }

    // File handling
    if (bannerMedia) {
      fd.append("bannerMedia", bannerMedia);
    }

    // 3. Handle asynchronous submission state properly
    try {
      setLoader(true);
      await onSubmit(fd);
    } catch (error) {
      console.error("Submission failed:", error);
    } finally {
      setLoader(false);
    }
  };

  return (
    <PageLayout
      onBack={onClose}
      onSubmit={submit}
      submitText={initialData ? "Update Banner" : "Create Banner"}
      loading={loader}
    >
      <form onSubmit={submit} className="flex flex-col gap-6">
        {alert && (
          <div ref={alertRef}>
            <Alert type="error" message={alert} onClose={() => setAlert("")} />
          </div>
        )}

        <FormSection title="Banner Details">
          <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
            <InputField
              label="Banner Title"
              name="title"
              value={form.title || ""}
              onChange={handleChange}
              placeholder="Enter title"
              error={errors.title}
              required
            />
            <SelectField
              label="Banner Type"
              name="banner_type"
              value={form.banner_type || ""}
              onChange={handleChange}
              options={[
                { label: "Hero", value: "Hero" },
                { label: "Popup", value: "Popup" },
                { label: "Bubble", value: "Bubble" },
                { label: "Flash", value: "Flash" },
              ]}
              placeholder="Search banner type..."
              isSearchable={true}
              required
              error={errors.banner_type}
            />
            <SelectField
              label="Banner Links To"
              name="links_to"
              value={form.links_to || ""}
              onChange={handleChange}
              options={[
                { label: "Common", value: "Common" },
                { label: "Event", value: "Event" },
                { label: "Exhibitor", value: "Exhibitor" },
              ]}
              placeholder="Search banner type..."
              isSearchable={true}
              required
              error={errors.links_to}
            />

            {form.links_to === "Common" && (
              <InputField
                label="Redirect URL"
                name="redirect_url"
                value={form.redirect_url || ""}
                onChange={handleChange}
                placeholder="Enter url"
                error={errors.redirect_url}
                required
              />
              // <Input
              //   label="Redirect URL"
              //   name="redirect_url"
              //   value={form.redirect_url}
              //   onChange={handleChange}
              //   required
              //   error={errors.redirect_url}
              // />
            )}

            {form.links_to === "Event" && (
              <SelectField
                label="Select Event"
                name="event_id"
                value={form.event_id || ""}
                onChange={handleChange}
                options={(data || []).map((item) => ({
                  value: item._id,
                  label: item.event_name,
                }))}
                placeholder="Search event..."
                isSearchable={true}
                required
                error={errors.event_id}
              />
              // <SelectInput
              //   label="Select Event"
              //   name="event_id"
              //   value={form.event_id}
              //   onChange={handleChange}
              //   required
              //   error={errors.event_id}
              // >
              //   <option value="">Select Event</option>
              //   {data.map((e) => (
              //     <option key={e._id} value={e._id}>
              //       {e.event_name}
              //     </option>
              //   ))}
              // </SelectInput>
            )}

            {form.links_to === "Exhibitor" && (
              <SelectField
                label="Select Exhibitor"
                name="exhibitor_id"
                value={form.exhibitor_id || ""}
                onChange={handleChange}
                options={(exhibitors || []).map((item) => ({
                  value: item._id,
                  label: item.title,
                }))}
                placeholder="Search event..."
                isSearchable={true}
                required
                error={errors.exhibitor_id}
              />
              // <SelectInput
              //   label="Select Exhibitor"
              //   name="exhibitor_id"
              //   value={form.exhibitor_id}
              //   onChange={handleChange}
              //   required
              //   error={errors.exhibitor_id}
              // >
              //   <option value="">Select Exhibitor</option>
              //   {exhibitors.map((e) => (
              //     <option key={e._id} value={e._id}>
              //       {e.title}
              //     </option>
              //   ))}
              // </SelectInput>
            )}
            <InputField
              type="datetime-local"
              label="Start Date & Time"
              name="start_date"
              value={form.start_date}
              onChange={handleChange}
              required
              error={errors.start_date}
            />
            <InputField
              type="datetime-local"
              label="End Date & Time"
              name="end_date"
              value={form.end_date || ""}
              onChange={handleChange}
              error={errors.end_date}
              required
            />
            <SelectField
              label="Media Type"
              name="mediaType"
              value={mediaType}
              onChange={handleChange}
              options={[
                { label: "Image", value: "image" },
                { label: "Video", value: "video" },
              ]}
              placeholder="Search media type..."
              isSearchable={true}
              required
              error={errors.mediaType}
            />
            <SelectField
              label="Banner Status"
              name="status"
              value={form.status || ""}
              onChange={handleChange}
              options={[
                { label: "Live", value: "live" },
                { label: "Inactive", value: "inactive" },
              ]}
              placeholder="Search status..."
              isSearchable={true}
              error={errors.status}
            />
          </div>
        </FormSection>
        <FormSection title="Banner Image">
          <p className="text-xs text-gray-500">
            Recommended resolution: <b>393×219 px</b>. Accepted file formats:
            <b> JPEG, PNG, MP4, WEPM</b>.
          </p>
          <ImageUploadField
            // label="Gallery Images"
            // multiple={true}
            // preview={formData.productImages||[]} // Array of URLs: ["blob:http...", "blob:http..."]
            onUpload={handleImageChange}
            // onRemove={(index) => handleRemoveGalleryImage(index)}
            showRemove={true}
            // name="existingImages"
            accept="image/*,video/*"
          />
          {errors.bannerMedia && (
            <p className="text-xs text-red-500">{errors.bannerMedia}</p>
          )}

          {preview && (
            <div className="grid grid-cols-2 gap-4 md:grid-cols-4">
              <div className="relative rounded-xl border p-2">
                {preview.type === "image" ? (
                  <img
                    src={preview.url}
                    alt="Preview"
                    className="h-32 w-full rounded-lg object-cover"
                  />
                ) : (
                  <video
                    src={preview.url}
                    controls
                    className="h-32 w-full rounded-lg object-cover"
                  />
                )}

                <button
                  type="button"
                  onClick={removeImage}
                  className="text-xs text-red-600"
                >
                  Remove media
                </button>
              </div>
            </div>
          )}
          <div className="mt-2 grid grid-cols-1 gap-5 md:grid-cols-2">
            <InputField
              label="Image Alt Text"
              name="alt_text"
              value={form.alt_text || ""}
              onChange={handleChange}
              error={errors.alt_text}
            />
          </div>
        </FormSection>
        <FormSection title="Visibility">
          <div className="flex flex-wrap gap-2.5">
            {VISIBILITY_ROLES.map((role) => {
              const isSelected = form.visibility?.includes(role);

              return (
                <button
                  type="button"
                  key={role}
                  onClick={() => toggleRole(role)}
                  style={
                    isSelected
                      ? {
                          borderColor: "var(--color-primary)",
                          color: "var(--color-primary)",
                        }
                      : {}
                  }
                  className={`rounded-[8px] border px-4 py-2 text-sm font-medium transition-all duration-200 ${
                    isSelected
                      ? " border-[var(--color-primary)] bg-white text-[var(--color-primary)] "
                      : "border-gray-200 bg-gray-50 text-gray-700 hover:border-gray-300 hover:bg-gray-100"
                  }`}
                >
                  {role}
                </button>
              );
            })}
          </div>
          {errors.visibility && (
            <p className="mt-1 text-xs font-medium text-red-500">
              {errors.visibility}
            </p>
          )}
        </FormSection>

        {/* <Section title="Banner Details"> */}
        {/* <Input
            label="Banner Title"
            name="title"
            value={form.title}
            onChange={handleChange}
            required
            error={errors.title}
          /> */}

        {/* <SelectInput
            label="Banner Type"
            name="banner_type"
            value={form.banner_type}
            onChange={handleChange}
            required
            error={errors.banner_type}
          >
            <option value="Hero">Hero</option>
            <option value="Popup">Popup</option>
            <option value="Bubble">Bubble</option>
            <option value="Flash">Flash</option>
         
          {/* <SelectInput
            label="Banner Links To"
            name="links_to"
            value={form.links_to}
            onChange={handleChange}
            required
            error={errors.links_to}
          >
            <option value="Common">Common</option>
            <option value="Event">Event</option>
            <option value="Exhibitor">Exhibitor</option>
          </SelectInput> */}

        {/* <Input
            type="datetime-local"
            label="Start Date & Time"
            name="start_date"
            value={form.start_date}
            onChange={handleChange}
            required
            error={errors.start_date}
          /> */}

        {/* <Input
            type="datetime-local"
            label="End Date & Time"
            name="end_date"
            value={form.end_date}
            onChange={handleChange}
            required
            error={errors.end_date}
          /> */}

        {/* <SelectInput
            label="Media Type"
            value={mediaType}
            onChange={(e) => {
              setMediaType(e.target.value);
              setPreview(null);
            }}
            required
            error={errors.media_type}
          >
            <option value="image">Image</option>
            <option value="video">Video</option>
          </SelectInput> */}

        {/* <div className="space-y-3 md:col-span-2"> */}
        {/* <input
              ref={fileInputRef}
              type="file"
              accept="image/png, image/jpeg,video/*"
              onChange={handleImageChange}
              className="w-full rounded-xl border p-3"
            /> */}
        {/* </div> */}

        {/* <Input
            label="Image Alt Text"
            name="alt_text"
            value={form.alt_text}
            onChange={handleChange}
          /> */}

        {/* <SelectInput
            label="Banner Status"
            name="status"
            value={form.status}
            onChange={handleChange}
          >
            <option value="live">Live</option>
            <option value="inactive">Inactive</option>
          </SelectInput> */}
        {/* </Section> */}

        {/* <div className="flex justify-between">
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl bg-red-500 px-6 py-3 text-white"
          >
            Back
          </button>

          <button
            type="submit"
            className="rounded-xl bg-brand-500 px-6 py-3 text-white"
          >
            {initialData ? "Update Banner" : "Publish Banner"}
          </button>
        </div> */}
        {/* <div className="button-div mt-6 flex justify-between">
          <button type="button" onClick={onClose} className="btn-cancel">
            Back
          </button>

          <button type="submit" className="btn-primary flex items-center gap-2">
            <span>{initialData ? "Update Banner" : "Create Banner"}</span>
            <FiArrowRight size={16} />
          </button>
        </div> */}
      </form>
    </PageLayout>
  );
}

// function Section({ title, children }) {
//   return (
//     <section>
//       <h3 className="mb-4 text-lg font-semibold">{title}</h3>
//       <div className="grid grid-cols-1 gap-5 md:grid-cols-2">{children}</div>
//     </section>
//   );
// }

// function Input({ label, required, error, ...props }) {
//   return (
//     <div>
//       <label className="mb-1 block text-sm font-medium">
//         {label}
//         {required && <span className="text-red-500">*</span>}
//       </label>
//       <input
//         {...props}
//         className={`w-full rounded-xl border p-3 ${
//           error ? "border-red-500" : ""
//         }`}
//       />
//       {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
//     </div>
//   );
// }

// function SelectInput({ label, required, error, children, ...props }) {
//   return (
//     <div>
//       <label className="mb-1 block text-sm font-medium">
//         {label}
//         {required && <span className="text-red-500">*</span>}
//       </label>
//       <select
//         {...props}
//         className={`w-full rounded-xl border p-3 ${
//           error ? "border-red-500" : ""
//         }`}
//       >
//         {children}
//       </select>
//       {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
//     </div>
//   );
// }
